// extracted by mini-css-extract-plugin
export default {"button--custom-color":"KakaoShareButton_button--custom-color__zFbPN"};